import React from "react";
import StackComponent from "../../components/Base/StackComponent";
import styled from "@emotion/styled";
import LinkComponent from "../../components/Base/LinkComponent";
import ButtonComponent from "../../components/Base/ButtonComponent";
const StyledLink = styled(LinkComponent)(({ theme }) => ({
  color: "black",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "14px",
}));
const LargeScreenNavMenus = ({ NAV_LINKS, navigate, isLoggedIn }) => {
  return (
    <>
      <StackComponent spacing="15px" sx={{ flexGrow: 1 }}>
        {NAV_LINKS.map((eachLink) => (
          <StyledLink isNav={true} to={eachLink.route} key={eachLink.name}>
            {eachLink.label}
          </StyledLink>
        ))}
      </StackComponent>
      <StackComponent alignItems="center" spacing="40px">
        {isLoggedIn ? (
          <ButtonComponent
            rounded
            width="120px"
            onClick={() => navigate("/home")}
          >
            My Account
          </ButtonComponent>
        ) : (
          <>
            <LinkComponent
              isNav={true}
              linkStyle={{
                color: "black",
                fontWeight: 500,
                fontSize: "18px",
                lineHeight: "14px",
              }}
              to="/login"
            >
              Login
            </LinkComponent>
            <ButtonComponent
              rounded
              width="120px"
              onClick={() => navigate("register")}
            >
              Sign Up
            </ButtonComponent>
          </>
        )}
      </StackComponent>
    </>
  );
};

export default LargeScreenNavMenus;
